// extracted by mini-css-extract-plugin
export default {"shareIcon":"PWAInstallPopupIOS_shareIcon__IswKZ","plusIcon":"PWAInstallPopupIOS_plusIcon__42DBw"};